import React, { FC, useState } from 'react';
import { Menu, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { ROUTES, StaticPagesWP } from 'constant';
import { history } from 'utils/history';
import { ContainerWrapper } from 'assets/styles/Container.style';
import Iframe from 'react-iframe';

export const FooterMenu: FC = () => {
  const { t } = useTranslation();
  const [showIframe, setShowIframe] = useState<boolean>(false);
  const [iframeLink, setIframeLink] = useState<string>(StaticPagesWP.AboutUs);

  const toggleIframeModal = (link?: string) => {
    link && setIframeLink(link);
    setShowIframe(!showIframe);
  };
  return (
    <ContainerWrapper>
      <Menu>
        <Menu.Item key="0">
          <a onClick={() => toggleIframeModal(StaticPagesWP.TermsOfUse)} rel="noreferrer" target="_blank">
            {t('Terms Of Use')}
          </a>
        </Menu.Item>
        <Menu.Item key="1">
          <a onClick={() => toggleIframeModal(StaticPagesWP.LegalPage)} rel="noreferrer" target="_blank">
            {t('Legal page')}
          </a>
        </Menu.Item>
        <Menu.Item key="2">
          <a onClick={() => toggleIframeModal(StaticPagesWP.AboutUs)} rel="noreferrer" target="_blank">
            {t('About Us')}
          </a>
        </Menu.Item>
        <Menu.Item key="3">
          <a onClick={() => toggleIframeModal(StaticPagesWP.Help)} rel="noreferrer" target="_blank">
            {t('Help')}
          </a>
        </Menu.Item>
        <Menu.Item key="4">
          <a onClick={() => history.push(ROUTES.BASE.PRICING_PLAN_PAGE)}>{t('Pricing')}</a>
        </Menu.Item>
      </Menu>
      <Modal visible={showIframe} onCancel={() => toggleIframeModal()} onOk={() => toggleIframeModal()}>
        <Iframe url={iframeLink} className="WPiframe" width="100%" height="100%" />
      </Modal>
    </ContainerWrapper>
  );
};
